import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import DoubleArrow from "../../../assets/double_arrow_circle.svg";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "w1brs0i"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c187k42b"
});
const TitleSection = /*#__PURE__*/styled("div")({
  name: "TitleSection",
  class: "t1voa8jj"
});
const BoxCollection = /*#__PURE__*/styled("div")({
  name: "BoxCollection",
  class: "b1sela50"
});
const Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "b19372zl"
});
const BoxRow = /*#__PURE__*/styled("div")({
  name: "BoxRow",
  class: "bn2zkzd",
  vars: {
    "bn2zkzd-0": [props => props.isDivider ? "24px" : "14px"],
    "bn2zkzd-1": [props => props.isDivider ? "#e0e0e0" : "unset"]
  }
});
const Button = /*#__PURE__*/styled("div")({
  name: "Button",
  class: "b17ij188",
  vars: {
    "b17ij188-1": [props => props.isOrange ? theme.orangePrimary : theme.blue6]
  }
});
const Divider = /*#__PURE__*/styled("div")({
  name: "Divider",
  class: "d5m19ix"
});
const ColoredBlock = /*#__PURE__*/styled("span")({
  name: "ColoredBlock",
  class: "cnyp7gf",
  vars: {
    "cnyp7gf-0": [props => props.isOrange ? theme.orange : theme.blue6]
  }
});

const ContactSolveProblem = () => {
  return <Wrapper>
      <div>
        <Container>
          <TitleSection>
            <h3>こんなお困りごと、コワーケーション.comで解決できます！</h3>
            <p>
              「体験」を探したい人、場をつなげる人、届ける人、それぞれの利用者に向けた機能が充実したコワーケーション.comだから、施設・コンテンツ事業者様のお悩みを解決できます。
            </p>
          </TitleSection>
          <BoxCollection>
            <Box>
              <BoxRow isDivider={false}>
                <Button>困りごと</Button>
                <p>
                  コロナ禍で法人営業ができず接点が激減。
                  <ColoredBlock>法人や団体の需要</ColoredBlock>
                  をうまく取り込めていない。
                </p>
              </BoxRow>
              <BoxRow isDivider={true}>
                <Divider />
                <DoubleArrow className="arrow" />
              </BoxRow>
              <BoxRow isDivider={false}>
                <Button isOrange>解決できること</Button>
                <p>
                  利用企業からの問い合わせに
                  <ColoredBlock isOrange>直接応対</ColoredBlock>
                  でき、かつ利用ニーズや具体的な要望を
                  <ColoredBlock isOrange>事前に</ColoredBlock>
                  知ることができる。
                </p>
              </BoxRow>
            </Box>
            <Box>
              <BoxRow isDivider={false}>
                <Button>困りごと</Button>
                <p>
                  <ColoredBlock>人員も不足</ColoredBlock>
                  していて、管理が煩雑なOTAを新たに増やす余裕はない。
                </p>
              </BoxRow>
              <BoxRow isDivider={false}>
                <Divider />
                <DoubleArrow className="arrow" />
              </BoxRow>
              <BoxRow isDivider={false}>
                <Button isOrange>解決できること</Button>
                <p>
                  事前の在庫出しや料金提示の必要はなく、問い合わせベースで、その時の
                  <ColoredBlock isOrange>稼働状況に合わせて</ColoredBlock>
                  提案することが可能。
                </p>
              </BoxRow>
            </Box>
            <Box>
              <BoxRow isDivider={false}>
                <Button>困りごと</Button>
                <p>
                  団体利用はありがたいが、事前のやりとりに
                  <ColoredBlock>多くの時間</ColoredBlock>
                  がとられる。
                </p>
              </BoxRow>
              <BoxRow isDivider={true}>
                <Divider />
                <DoubleArrow className="arrow" />
              </BoxRow>
              <BoxRow isDivider={false}>
                <Button isOrange>解決できること</Button>
                <p>
                  煩雑なやりとりを<ColoredBlock isOrange>一元管理</ColoredBlock>
                  できるので、宿泊者数の増減やリクエスト情報の管理の
                  <ColoredBlock isOrange>手間を軽減</ColoredBlock>します。
                </p>
              </BoxRow>
            </Box>
          </BoxCollection>
        </Container>
      </div>
    </Wrapper>;
};

export { ContactSolveProblem };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");